import { render, staticRenderFns } from "./NativeCampaignEdit.vue?vue&type=template&id=24b16c0a&scoped=true"
import script from "./NativeCampaignEdit.vue?vue&type=script&lang=js"
export * from "./NativeCampaignEdit.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NativeCampaignEdit.vue?vue&type=style&index=1&id=24b16c0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b16c0a",
  null
  
)

export default component.exports